export default __webpack_public_path__ + "static/top-nav-dont-2-0983905f1a6423db19a62b9d0a6bbc31085072c40b767e6801ccce07e25dcc0a.png";